module.exports = __webpack_public_path__ + "static/media/blockerwhite.e6900539.svg";